import { useState, useEffect } from 'react';

const STORAGE_KEY = 'comunicado_042026_dismissed';

interface ComunicadoModalProps {
  onClose: () => void;
}

export default function ComunicadoModal({ onClose }: ComunicadoModalProps) {
  const [naoMostrarMais, setNaoMostrarMais] = useState(false);

  const handleClose = () => {
    if (naoMostrarMais) {
      localStorage.setItem(STORAGE_KEY, 'true');
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-6 animate-[fadeIn_0.25s_ease-out]">
      <div className="bg-white rounded-2xl w-full overflow-hidden animate-[scaleIn_0.25s_ease-out]" style={{ maxWidth: '680px' }}>
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
              <i className="ri-megaphone-line text-orange-600 text-base"></i>
            </div>
            <span className="text-sm font-bold text-slate-800">Comunicado</span>
          </div>
          <button
            onClick={handleClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl text-slate-500"></i>
          </button>
        </div>

        {/* Imagem do comunicado */}
        <div className="w-full">
          <img
            src="https://storage.readdy-site.link/project_files/d3ef49a8-8963-4d4a-ac5c-718f7ab578ff/e0175645-3557-4906-987d-e0442a6c1a3b_getpoints_comunicado042026.png?v=160877d79f49328d7c99f03a7cdf3413"
            alt="Comunicado GetPoints - Abril 2026"
            className="w-full h-auto block"
          />
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t border-slate-100 flex items-center justify-between gap-4">
          <label className="flex items-center gap-2 cursor-pointer group select-none">
            <input
              type="checkbox"
              checked={naoMostrarMais}
              onChange={(e) => setNaoMostrarMais(e.target.checked)}
              className="w-4 h-4 text-orange-500 border-slate-300 rounded focus:ring-orange-500 cursor-pointer"
            />
            <span className="text-sm text-slate-600 group-hover:text-slate-800 transition-colors">
              Não mostrar novamente
            </span>
          </label>

          <button
            onClick={handleClose}
            className="px-5 py-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg text-sm font-semibold hover:from-orange-600 hover:to-orange-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Entendido
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

export { STORAGE_KEY };
